module.exports = __webpack_public_path__ + "img/2.4338330c.png";